import { render, staticRenderFns } from "./QuotaLimitPeriod.vue?vue&type=template&id=a36ea222&"
import script from "./QuotaLimitPeriod.vue?vue&type=script&lang=js&"
export * from "./QuotaLimitPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports